export default "__VITE_ASSET__CZoX58yc__"